import React, { useEffect, useState } from "react";
import { Modal, Button, message, Typography } from "antd";
import { useMutation } from '@apollo/client';
import { UPDATE_GROUP_PRIORITY } from "./requests";
import { couponTypes } from "../../../../types";
import DragTable from "./components/DragTable";

const { Text } = Typography;

type PriorityGroupProps = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  refetch: () => void;
  data: {
    groupsCoupon: {
      results: typeof couponTypes.groupCoupon[];
    };
  };
  sortRefetch: () => void;
};

const PriorityGroup: React.FC<PriorityGroupProps> = ({ showModal, setShowModal, refetch, data, sortRefetch }) => {
  const [groupsCoupon, setGroupsCoupon] = useState<typeof couponTypes.groupCoupon[]>([]);
  const [loading, setLoading] = useState(false);

  const [updateGroupPriority] = useMutation(UPDATE_GROUP_PRIORITY);

  console.log({ data })

  useEffect(() => {
    setLoading(true);
    if (data && data.groupsCoupon && data.groupsCoupon.results) {
      setGroupsCoupon(data.groupsCoupon.results.map((group: typeof couponTypes.groupCoupon, index: number) => ({
        ...group,
        priority: index + 1,
      })));
    } else {
      setGroupsCoupon([]);
    }
    setLoading(false);
  }, [data, showModal]);

  const handleDragEnd = (newGroupsCoupon: typeof couponTypes.groupCoupon[]) => {
    const updatedGroupsCoupon = newGroupsCoupon.map((group, index) => ({
      ...group,
      priority: index + 1,
    }));

    setGroupsCoupon(updatedGroupsCoupon);
  };

  const handleSubmit = async () => {
    const groupsCouponInput = groupsCoupon.map((group, index) => ({
      id: group.id,
      priority: index + 1,
    }));

    try {
      const response = await updateGroupPriority({
        variables: { groups: groupsCouponInput },
      });
      if (response.data.updateGroupPriority) {
        message.success('Prioridades actualizadas correctamente');
        await refetch();
        await sortRefetch();
      } else {
        message.error('Error al actualizar las prioridades');
      }
    } catch (error) {
      console.error(error);
      message.error('Hubo un problema al actualizar las prioridades');
    } finally {
      setShowModal(false);
    }
  };

  return (
    <Modal
      title="Actualizar Prioridades"
      open={showModal}
      onCancel={() => setShowModal(false)}
      footer={[
        <Button key="cancel" onClick={() => setShowModal(false)}>
          Cancelar
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Guardar
        </Button>,
      ]}
    >
      <Text>Para cambiar el orden de las prioridades, arrastra las filas de la tabla a la posición deseada.</Text>

      <DragTable
        data={groupsCoupon}
        onDragEnd={handleDragEnd}
        columns={[
          { title: "Orden",
            dataIndex: "priority",
            key: "priority" },
          { title: "Nombre del Grupo",
            dataIndex: "group",
            key: "group" },
        ]}
        loading={loading}
      />
    </Modal>
  );
};

export default PriorityGroup;
